<template>
    <div style="margin-top: 10px; margin-left: 30px;">
        <el-card shadow="hover" class="document-card">

            <el-row :gutter="20">
                <el-col :span="7">
                    <el-button type="primary">
                        质量评估
                    </el-button>
                </el-col>

            </el-row>
            <el-row :gutter="20" type="flex" justify="end" style="margin-bottom: 20px;">
                <el-col :span="12">
                    <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
                        <el-select v-model="authState" placeholder="评估状态" style="width: 125px;"
                            @change="handleFilterChange">
                            <el-option label="全部" value="全部"></el-option>
                            <el-option label="待申请" value="待申请"></el-option>
                            <el-option label="审核中" value="审核中"></el-option>
                            <el-option label="评估完成" value="评估完成"></el-option>
                            <el-option label="评估驳回" value="评估驳回"></el-option>

                        </el-select>
                        <el-input v-model="assetName" placeholder="请输入资产名称..." style="width: 350px;"
                            @keydown.enter.native="doSearch" class="search-input">
                            <el-button slot="append" icon="el-icon-search" @click="doSearch"
                                style="background-color: #1E88E5; color: white;">搜索</el-button>
                        </el-input>
                    </div>
                </el-col>
            </el-row>


            <component v-bind:is="currentName" @changeName="changeName"></component>
            <div class="table" v-if="currentName === ''" style="margin-top: 20px; width: 100%; box-sizing: border-box;">
                <el-table :data="tableData" border :fit="true" style="width: 100%"
                    :header-cell-style="{ background: '#f5f5f5' }">
                    <el-table-column type="index" label="序号" width="50" fixed="left" align="center">
                    </el-table-column>

                    <el-table-column prop="registrationId" label="资产登记编号" min-width="170" align="center">
                    </el-table-column>

                    <el-table-column prop="assetName" label="资产登记名称" min-width="270" align="center">
                    </el-table-column>

                    <el-table-column prop="industry" label="行业类别" min-width="240" align="center">
                    </el-table-column>

                    <el-table-column prop="state" label="评估状态" min-width="80" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.state }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="dataQualityScore" label="综合得分" min-width="80" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.dataQualityScore ? scope.row.dataQualityScore : "-" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="evaluationReport" label="评估报告" width="210" align="center">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.evaluationReport" type="primary" @click="downloadFile(scope.row)">
                                {{ scope.row.evaluationReport }}
                            </el-link>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" min-width="100" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.state === '审核中'" size="mini" type="info" style="
                                    color: #fff;
                                    padding: 7px 12px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    transition: all 0.3s;
                                ">
                                等待结果
                            </el-button>
                            <el-button v-if="scope.row.state === '评估完成'" size="mini" type="success"
                                @click="handleView(scope.row)" style="
                                    background-color: #67C23A;
                                    border-color: #67C23A;
                                    color: #fff;
                                    padding: 7px 12px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    transition: all 0.3s;
                                ">
                                查看详情
                            </el-button>
                            <el-button v-if="scope.row.state === '待申请' || scope.row.state === null" size="mini"
                                type="primary" @click="handleApply(scope.row)" style="
                                    color: #fff;
                                    padding: 7px 12px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    transition: all 0.3s;
                                ">
                                评估申请
                            </el-button>
                            <el-button v-if="scope.row.state === '评估驳回'" size="mini" type="danger"
                                @click="handleReapply(scope.row)" style="
                                    background-color: #F56C6C;
                                    border-color: #F56C6C;
                                    color: #fff;
                                    padding: 7px 12px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    transition: all 0.3s;
                                ">
                                重新评估
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <div v-if="currentName === ''" class="block" style="display: flex; justify-content: center; margin-top: 20px">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="boardsTotal"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :current-page="currPage"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="5"
                :background="true">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import AddBoardContent from "../../../components/AddBoardContent";

export default {
    name: "DataQualityShowList",
    data() {
        return {
            boardsTotal: 1,
            currPage: 1,
            pageSize: 10,
            assetName: '',
            currentName: '',
            authState: '全部',
            tableData: [],
        }
    },
    components: {
        AddBoardContent
    },
    watch: {},
    mounted() {
        this.initTableData('');
    },
    methods: {
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-'

            const date = new Date(dateTime)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')

            return `${year}-${month}-${day} ${hours}:${minutes}`
        },

        // 分页
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData(this.assetName);
        },
        // 分页

        handleSizeChange(val) {
            this.pageSize = val;
            this.initTableData(this.assetName);
        },

        // 下载文件
        async downloadFile(row) {
            console.log(row);
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/dataQuality/download?registrationId=' + row.registrationId + '&fileName=' + row.evaluationReport,
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', row.evaluationReport);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        // 初始化数据
        initTableData(assetName) {

            let user = JSON.parse(window.localStorage.getItem('user'));


            this.$axios.get('/web/dataQuality/queryListByUserId', {
                params: {
                    assetName: assetName,
                    state: this.authState,
                    currPage: this.currPage,
                    pageSize: this.pageSize
                },
                headers: {
                    'X-User-Id': user.id
                }
            }).then(resp => {
                console.log(resp);
                if (resp) {
                    this.boardsTotal = resp.data.total;
                    this.tableData = resp.data.list;
                }
            }).catch(error => {
                console.error('请求失败:', error.response);
            });
        },

        // 搜索
        doSearch() {
            this.$router.push({
                path: this.$route.path,
                query: { ...this.$route.query, keyword: this.assetName }
            });
            this.initTableData(this.assetName);
        },

        // 筛选
        handleFilterChange(value) {
            this.state = value;
            this.initTableData(); // 筛选条件变化时重新加载数据
        },
        changeName(name) {
            //console.log(this.currentName)
            this.currentName = name;
            if (name === '') {
                this.initTableData('');
                this.$store.commit('REMOVE_CURRENT_BOARD_ID');
            }
        },
        handleReapply(row) {
            this.$router.push({
                path: '/data-quality-apply',
                query: { registrationId: row.registrationId, userId: JSON.parse(window.localStorage.getItem('user')).id }
            });
        },
        handleView(row) {
            this.$router.push({
                path: '/data-quality-detail',
                query: { registrationId: row.registrationId }
            });
        },
        handleApply(row) {
            this.$router.push({
                path: '/data-quality-apply',
                query: { registrationId: row.registrationId, userId: JSON.parse(window.localStorage.getItem('user')).id }
            });
        },

        handleOpenPublicPage(row) {
            if (row.state === '平台公示中') {
                const url = this.$router.resolve({
                    path: '/infoPublic'
                }).href;
                window.open(url, '_blank');
            }
        }
    }
}
</script>

<style scoped>
/* 按钮统一样式 */
.el-button--mini {
    min-width: 60px;
    height: 28px;
    line-height: 1;
}

/* 编辑按钮效果 */
.el-button--success {
    background-color: #67C23A;
    border-color: #67C23A;
}

.el-button--success:hover {
    background-color: #85ce61 !important;
    border-color: #85ce61 !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(103, 194, 58, 0.3);
}

.el-button--success:active {
    transform: translateY(0);
    box-shadow: none;
}

/* 删除按钮效果 */
.el-button--danger {
    background-color: #F56C6C;
    border-color: #F56C6C;
}

.el-button--danger:hover {
    background-color: #f78989 !important;
    border-color: #f78989 !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(245, 108, 108, 0.3);
}

.el-button--danger:active {
    transform: translateY(0);
    box-shadow: none;
}

/* 分页组件优化 */
.el-pagination.is-background {
    padding: 15px 0;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409EFF;
    color: #fff;
    font-weight: bold;
}

.el-pagination.is-background .el-pager li:hover {
    color: #409EFF;
}

.el-pagination__jump {
    margin-left: 10px;
}



/* 表头样式 */
.document-card>>>.el-table__header th {
    text-align: center;
    font-size: 14px;
    color: rgb(46, 44, 44);
}

/* 状态列可点击样式 */
.document-card>>>.el-table__body .el-table__cell span[style*="color"] {
    cursor: pointer;
    /*  下划线 */
    text-decoration: underline;
}
</style>
